import { Star, Award, Building2, ArrowRight } from "lucide-react";

const RUNNING_WILD_LOGO =
  "https://customer-assets.emergentagent.com/job_paw-book-system/artifacts/bbbqebql_1.png";

const ITEMS = [
  {
    key: "reviews",
    icon: <Star className="w-7 h-7" strokeWidth={1.6} />,
    headline: "61 Facebook reviews · 100% recommend",
    cta: "Read reviews",
    href: "https://facebook.com/pawsnplaygroomcatlodgerescue",
    external: true,
  },
  {
    key: "certified",
    icon: <Award className="w-7 h-7" strokeWidth={1.6} />,
    headline: "Master Groomer Certified",
    cta: "Learn more",
    href: "#why",
  },
  {
    key: "rescue",
    icon: (
      <span className="trust-strip__rescue-thumb">
        <img src={RUNNING_WILD_LOGO} alt="Running Wild Rescue" loading="lazy" />
      </span>
    ),
    headline: "Proud Partner of Running Wild Rescue",
    cta: "Our rescue work",
    href: "#rescue",
  },
  {
    key: "chamber",
    icon: <Building2 className="w-7 h-7" strokeWidth={1.6} />,
    headline: "Proud Member of Moose Jaw Chamber of Commerce",
    cta: "View listing",
    href: "https://www.mjchamber.com/list/member/pup-s-parlour-inc-2791",
    external: true,
  },
];

export default function TrustStrip({ variant = "section" }) {
  return (
    <section className={`trust-strip trust-strip--${variant}`} data-testid="trust-strip">
      <div className="trust-strip__inner">
        {ITEMS.map((item) => (
          <div className="trust-strip__item" key={item.key} data-testid={`trust-${item.key}`}>
            <div className="trust-strip__icon">{item.icon}</div>
            <div className="trust-strip__copy">
              <p className="trust-strip__headline">{item.headline}</p>
              <a
                href={item.href}
                target={item.external ? "_blank" : undefined}
                rel={item.external ? "noopener noreferrer" : undefined}
                className="trust-strip__cta"
              >
                {item.cta}
                <ArrowRight className="w-3 h-3" />
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
